import React from 'react'
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { userPayload } from "Pages/Admin/Users/@signals"
import { AppAntSwitch } from "@components"

export default function UserIsMasterSwitch() {

	const { isMaster, setIsMasterInfo } = useAdminUsersInfo(userPayload.peek()?.user?.isMaster, "isMaster", "user")
	return <AppAntSwitch
		checked={isMaster}
		falseText="Is Master"
		onChange={e => setIsMasterInfo(e.target.checked)}
	/>
}